export enum TenantRoutes {
  root = 'tenant',
  create = 'create-tenant',
  signup = 'signup',
  processing = 'processing',
}
